// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_entitlement_user_binding.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { UserRef } from "../../user/v1/user";
import { AppRef } from "./app";
import { AppUserRef } from "./app_user";
import { AppEntitlementUserBindingRef } from "./app_refs";
import { AppEntitlementRef } from "./app_refs";
import { Any } from "../../../../google/protobuf/any";
import { GrantReason } from "./app_entitlement_user_binding_reasons";
import { Timestamp } from "../../../../google/protobuf/timestamp";
/**
 * @generated from protobuf message c1.api.app.v1.UpdateGrantDurationRequest
 */
export interface UpdateGrantDurationRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 3
     */
    appUserId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp new_deprovision_at = 4
     */
    newDeprovisionAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.app.v1.UpdateGrantDurationResponse
 */
export interface UpdateGrantDurationResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBinding binding = 1
     */
    binding?: AppEntitlementUserBinding;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementUserBindingWithReasons
 */
export interface AppEntitlementUserBindingWithReasons {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppAppUserEntitlementIds scope = 1
     */
    scope?: AppAppUserEntitlementIds;
    /**
     * @generated from protobuf field: string app_user_path = 2
     */
    appUserPath: string;
    /**
     * @generated from protobuf field: string entitlement_path = 3
     */
    entitlementPath: string;
    /**
     * @generated from protobuf field: string app_path = 4
     */
    appPath: string;
    /**
     * @generated from protobuf field: string user_path = 5
     */
    userPath: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBinding binding = 6
     */
    binding?: AppEntitlementUserBinding;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.GrantReason reasons = 7
     */
    reasons: GrantReason[];
    /**
     * @generated from protobuf field: string app_id = 8
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 9
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 10
     */
    appUserId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deprovision_at = 11
     */
    deprovisionAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListMembershipsResponse
 */
export interface ListMembershipsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBindingWithReasons list = 1
     */
    list: AppEntitlementUserBindingWithReasons[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.ListMembershipsRequest
 */
export interface ListMembershipsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3
     */
    query: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementRef entitlement_ref = 4
     */
    entitlementRef?: AppEntitlementRef;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBindingExpandMask expand_mask = 5
     */
    expandMask?: AppEntitlementUserBindingExpandMask;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBindingRef refs = 6
     */
    refs: AppEntitlementUserBindingRef[];
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppUsersForIdentityWithGrantRequest
 */
export interface ListAppUsersForIdentityWithGrantRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string identity_user_id = 3
     */
    identityUserId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppUsersForIdentityWithGrantResponse
 */
export interface ListAppUsersForIdentityWithGrantResponse {
    /**
     * The list of app users that may also have grant information.
     * Without a grant, only the tenant, app, and app user ID will be set. With a grant, the whole struct is populated
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBinding bindings = 1
     */
    bindings: AppEntitlementUserBinding[];
}
/**
 * The AppEntitlementUserBinding represents the relationship that gives an app user access to an app entitlement
 *
 * @generated from protobuf message c1.api.app.v1.AppEntitlementUserBinding
 */
export interface AppEntitlementUserBinding {
    /**
     * The ID of the app associated with the app entitlement
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The ID of the app entitlement that the app user has access to
     *
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * The ID of the app user that has access to the app entitlement
     *
     * @generated from protobuf field: string app_user_id = 3
     */
    appUserId: string;
    /**
     * The datetime, in RFC3339 format, of when the AppEntitlementUserBinding was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AppEntitlementUserBinding was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5
     */
    deletedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AppEntitlementUserBinding should be deprovisioned, a revoke ticket will automatically be created at this time.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deprovision_at = 6
     */
    deprovisionAt?: Timestamp;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef grant_sources = 7
     */
    grantSources: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementUserBindingHistory
 */
export interface AppEntitlementUserBindingHistory {
    /**
     * The ID of the app associated with the app entitlement
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The ID of the app entitlement that the app user has access to
     *
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * The ID of the app user that has access to the app entitlement
     *
     * @generated from protobuf field: string app_user_id = 3
     */
    appUserId: string;
    /**
     * The datetime, in RFC3339 format, of when the AppEntitlement was granted
     *
     * @generated from protobuf field: google.protobuf.Timestamp granted_at = 4
     */
    grantedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AppEntitlement was revoked
     *
     * @generated from protobuf field: google.protobuf.Timestamp revoked_at = 5
     */
    revokedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementUserBindingExpandHistoryMask
 */
export interface AppEntitlementUserBindingExpandHistoryMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementUserBindingHistoryView
 */
export interface AppEntitlementUserBindingHistoryView {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBindingHistory history = 1
     */
    history?: AppEntitlementUserBindingHistory;
    /**
     * @generated from protobuf field: string app_user_path = 2
     */
    appUserPath: string;
    /**
     * @generated from protobuf field: string entitlement_path = 3
     */
    entitlementPath: string;
    /**
     * @generated from protobuf field: string app_path = 4
     */
    appPath: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchPastGrantsRequest
 */
export interface SearchPastGrantsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBindingExpandHistoryMask expand_mask = 4
     */
    expandMask?: AppEntitlementUserBindingExpandHistoryMask;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef app_user_refs = 5
     */
    appUserRefs: AppUserRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 6
     */
    appEntitlementRefs: AppEntitlementRef[];
    /**
     * @generated from protobuf field: repeated string app_ids = 7
     */
    appIds: string[];
}
/**
 * The SearchPastGrantsResponse message contains a list of past grants and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.app.v1.SearchPastGrantsResponse
 */
export interface SearchPastGrantsResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBindingHistoryView list = 1
     */
    list: AppEntitlementUserBindingHistoryView[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retrieved.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementUserBindingFeed
 */
export interface AppEntitlementUserBindingFeed {
    /**
     * The ID of the app associated with the app entitlement
     *
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * The ID of the app entitlement that the app user has access to
     *
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * The ID of the app user that has access to the app entitlement
     *
     * @generated from protobuf field: string app_user_id = 3
     */
    appUserId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp date = 4
     */
    date?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.app.v1.GrantEventType event_type = 5
     */
    eventType: GrantEventType;
    /**
     * @generated from protobuf field: string ticket_id = 6
     */
    ticketId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementUserBindingFeedView
 */
export interface AppEntitlementUserBindingFeedView {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBindingFeed feed = 1
     */
    feed?: AppEntitlementUserBindingFeed;
    /**
     * @generated from protobuf field: string app_user_path = 2
     */
    appUserPath: string;
    /**
     * @generated from protobuf field: string entitlement_path = 3
     */
    entitlementPath: string;
    /**
     * @generated from protobuf field: string app_path = 4
     */
    appPath: string;
    /**
     * @generated from protobuf field: string ticket_path = 5
     */
    ticketPath: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchGrantFeedRequest
 */
export interface SearchGrantFeedRequest {
    /**
     * The pageSize where 10 <= pageSize <= 100, default 25.
     *
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * The page_token field for pagination.
     *
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * Control the array of expanded values that are filled out in the response to this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBindingExpandHistoryMask expand_mask = 3
     */
    expandMask?: AppEntitlementUserBindingExpandHistoryMask;
    /**
     * The list of app users to limit the search to.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef app_user_refs = 4
     */
    appUserRefs: AppUserRef[];
    /**
     * The list of app entitlements to limit the search to.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 5
     */
    appEntitlementRefs: AppEntitlementRef[];
    /**
     * Search grant feed, in RFC3339 format, that were created before this timestamp.
     *
     * @generated from protobuf field: google.protobuf.Timestamp before = 6
     */
    before?: Timestamp;
    /**
     * Search grant feed, in RFC3339 format, that were created after this timestamp.
     *
     * @generated from protobuf field: google.protobuf.Timestamp after = 7
     */
    after?: Timestamp;
    /**
     * The list of apps to limit the search to.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppRef app_refs = 8
     */
    appRefs: AppRef[];
    /**
     * The list of C1 users to limit the search to.
     *
     * @generated from protobuf field: repeated c1.api.user.v1.UserRef user_refs = 9
     */
    userRefs: UserRef[];
}
/**
 * The SearchGrantFeedResponse message contains a list of grant event results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.app.v1.SearchGrantFeedResponse
 */
export interface SearchGrantFeedResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBindingFeedView list = 1
     */
    list: AppEntitlementUserBindingFeedView[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retrieved.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementUserBindingExpandMask
 */
export interface AppEntitlementUserBindingExpandMask {
    /**
     * @generated from protobuf field: repeated string paths = 1
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppUsersWithStandingHighRiskGrantsRequest
 */
export interface SearchAppUsersWithStandingHighRiskGrantsRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBindingExpandMask expand_mask = 4
     */
    expandMask?: AppEntitlementUserBindingExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppAppUserEntitlementIds
 */
export interface AppAppUserEntitlementIds {
    /**
     * @generated from protobuf field: string app_user_id = 1
     */
    appUserId: string;
    /**
     * @generated from protobuf field: string entitlement_id = 2
     */
    entitlementId: string;
    /**
     * @generated from protobuf field: string app_id = 3
     */
    appId: string;
    /**
     * @generated from protobuf field: string user_id = 4
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementUserBindingExpanded
 */
export interface AppEntitlementUserBindingExpanded {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppAppUserEntitlementIds scope = 1
     */
    scope?: AppAppUserEntitlementIds;
    /**
     * @generated from protobuf field: string app_user_path = 2
     */
    appUserPath: string;
    /**
     * @generated from protobuf field: string entitlement_path = 3
     */
    entitlementPath: string;
    /**
     * @generated from protobuf field: string app_path = 4
     */
    appPath: string;
    /**
     * @generated from protobuf field: string user_path = 5
     */
    userPath: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppUsersWithStandingHighRiskGrantsResponse
 */
export interface SearchAppUsersWithStandingHighRiskGrantsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBindingExpanded list = 1
     */
    list: AppEntitlementUserBindingExpanded[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListGrantOriginsRequest
 */
export interface ListGrantOriginsRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 3
     */
    appUserId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.GrantOriginWithData
 */
export interface GrantOriginWithData {
    /**
     * @generated from protobuf field: string origin_type = 1
     */
    originType: string;
    /**
     * @generated from protobuf field: repeated string origin_data = 2
     */
    originData: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.ListGrantOriginsResponse
 */
export interface ListGrantOriginsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.GrantOriginWithData origins = 1
     */
    origins: GrantOriginWithData[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchGrantReasonsRequest
 */
export interface SearchGrantReasonsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string app_id = 3
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 4
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 5
     */
    appUserId: string;
    /**
     * @generated from protobuf field: repeated string grant_reason_types = 6
     */
    grantReasonTypes: string[];
    /**
     * @generated from protobuf field: bool include_weak_reasons = 7
     */
    includeWeakReasons: boolean;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchGrantReasonsResponse
 */
export interface SearchGrantReasonsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.GrantReason reasons = 1
     */
    reasons: GrantReason[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.GrantSource
 */
export interface GrantSource {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetAppEntitlementUserBindingRequest
 */
export interface GetAppEntitlementUserBindingRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 3
     */
    appUserId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetAppEntitlementUserBindingResponse
 */
export interface GetAppEntitlementUserBindingResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBinding binding = 1
     */
    binding?: AppEntitlementUserBinding;
}
/**
 * @generated from protobuf message c1.api.app.v1.RemoveGrantDurationRequest
 */
export interface RemoveGrantDurationRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 3
     */
    appUserId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.RemoveGrantDurationResponse
 */
export interface RemoveGrantDurationResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserBinding binding = 1
     */
    binding?: AppEntitlementUserBinding;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchExpiringAppEntitlementsCountRequest
 */
export interface SearchExpiringAppEntitlementsCountRequest {
    /**
     * @generated from protobuf field: string app_id = 1
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2
     */
    appEntitlementId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchExpiringAppEntitlementsCountResponse
 */
export interface SearchExpiringAppEntitlementsCountResponse {
    /**
     * @generated from protobuf field: int64 count = 1
     */
    count: number;
}
/**
 * @generated from protobuf enum c1.api.app.v1.GrantEventType
 */
export enum GrantEventType {
    /**
     * @generated from protobuf enum value: GRANT_EVENT_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: GRANT_EVENT_TYPE_ADDED = 1;
     */
    ADDED = 1,
    /**
     * @generated from protobuf enum value: GRANT_EVENT_TYPE_REMOVED = 2;
     */
    REMOVED = 2
}
// @generated message type with reflection information, may provide speed optimized methods
class UpdateGrantDurationRequest$Type extends MessageType<UpdateGrantDurationRequest> {
    constructor() {
        super("c1.api.app.v1.UpdateGrantDurationRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "new_deprovision_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<UpdateGrantDurationRequest>): UpdateGrantDurationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.appUserId = "";
        if (value !== undefined)
            reflectionMergePartial<UpdateGrantDurationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateGrantDurationRequest): UpdateGrantDurationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string app_user_id */ 3:
                    message.appUserId = reader.string();
                    break;
                case /* google.protobuf.Timestamp new_deprovision_at */ 4:
                    message.newDeprovisionAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.newDeprovisionAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateGrantDurationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string app_user_id = 3; */
        if (message.appUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appUserId);
        /* google.protobuf.Timestamp new_deprovision_at = 4; */
        if (message.newDeprovisionAt)
            Timestamp.internalBinaryWrite(message.newDeprovisionAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpdateGrantDurationRequest
 */
export const UpdateGrantDurationRequest = new UpdateGrantDurationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateGrantDurationResponse$Type extends MessageType<UpdateGrantDurationResponse> {
    constructor() {
        super("c1.api.app.v1.UpdateGrantDurationResponse", [
            { no: 1, name: "binding", kind: "message", T: () => AppEntitlementUserBinding }
        ]);
    }
    create(value?: PartialMessage<UpdateGrantDurationResponse>): UpdateGrantDurationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<UpdateGrantDurationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: UpdateGrantDurationResponse): UpdateGrantDurationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementUserBinding binding */ 1:
                    message.binding = AppEntitlementUserBinding.internalBinaryRead(reader, reader.uint32(), options, message.binding);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: UpdateGrantDurationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementUserBinding binding = 1; */
        if (message.binding)
            AppEntitlementUserBinding.internalBinaryWrite(message.binding, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpdateGrantDurationResponse
 */
export const UpdateGrantDurationResponse = new UpdateGrantDurationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementUserBindingWithReasons$Type extends MessageType<AppEntitlementUserBindingWithReasons> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementUserBindingWithReasons", [
            { no: 1, name: "scope", kind: "message", T: () => AppAppUserEntitlementIds },
            { no: 2, name: "app_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "entitlement_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "binding", kind: "message", T: () => AppEntitlementUserBinding },
            { no: 7, name: "reasons", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GrantReason },
            { no: 8, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "deprovision_at", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementUserBindingWithReasons>): AppEntitlementUserBindingWithReasons {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appUserPath = "";
        message.entitlementPath = "";
        message.appPath = "";
        message.userPath = "";
        message.reasons = [];
        message.appId = "";
        message.appEntitlementId = "";
        message.appUserId = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementUserBindingWithReasons>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementUserBindingWithReasons): AppEntitlementUserBindingWithReasons {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppAppUserEntitlementIds scope */ 1:
                    message.scope = AppAppUserEntitlementIds.internalBinaryRead(reader, reader.uint32(), options, message.scope);
                    break;
                case /* string app_user_path */ 2:
                    message.appUserPath = reader.string();
                    break;
                case /* string entitlement_path */ 3:
                    message.entitlementPath = reader.string();
                    break;
                case /* string app_path */ 4:
                    message.appPath = reader.string();
                    break;
                case /* string user_path */ 5:
                    message.userPath = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementUserBinding binding */ 6:
                    message.binding = AppEntitlementUserBinding.internalBinaryRead(reader, reader.uint32(), options, message.binding);
                    break;
                case /* repeated c1.api.app.v1.GrantReason reasons */ 7:
                    message.reasons.push(GrantReason.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string app_id */ 8:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 9:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string app_user_id */ 10:
                    message.appUserId = reader.string();
                    break;
                case /* google.protobuf.Timestamp deprovision_at */ 11:
                    message.deprovisionAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deprovisionAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementUserBindingWithReasons, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppAppUserEntitlementIds scope = 1; */
        if (message.scope)
            AppAppUserEntitlementIds.internalBinaryWrite(message.scope, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string app_user_path = 2; */
        if (message.appUserPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appUserPath);
        /* string entitlement_path = 3; */
        if (message.entitlementPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.entitlementPath);
        /* string app_path = 4; */
        if (message.appPath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appPath);
        /* string user_path = 5; */
        if (message.userPath !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.userPath);
        /* c1.api.app.v1.AppEntitlementUserBinding binding = 6; */
        if (message.binding)
            AppEntitlementUserBinding.internalBinaryWrite(message.binding, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.GrantReason reasons = 7; */
        for (let i = 0; i < message.reasons.length; i++)
            GrantReason.internalBinaryWrite(message.reasons[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* string app_id = 8; */
        if (message.appId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 9; */
        if (message.appEntitlementId !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string app_user_id = 10; */
        if (message.appUserId !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.appUserId);
        /* google.protobuf.Timestamp deprovision_at = 11; */
        if (message.deprovisionAt)
            Timestamp.internalBinaryWrite(message.deprovisionAt, writer.tag(11, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementUserBindingWithReasons
 */
export const AppEntitlementUserBindingWithReasons = new AppEntitlementUserBindingWithReasons$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListMembershipsResponse$Type extends MessageType<ListMembershipsResponse> {
    constructor() {
        super("c1.api.app.v1.ListMembershipsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBindingWithReasons },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<ListMembershipsResponse>): ListMembershipsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<ListMembershipsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListMembershipsResponse): ListMembershipsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementUserBindingWithReasons list */ 1:
                    message.list.push(AppEntitlementUserBindingWithReasons.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListMembershipsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementUserBindingWithReasons list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementUserBindingWithReasons.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListMembershipsResponse
 */
export const ListMembershipsResponse = new ListMembershipsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListMembershipsRequest$Type extends MessageType<ListMembershipsRequest> {
    constructor() {
        super("c1.api.app.v1.ListMembershipsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "entitlement_ref", kind: "message", T: () => AppEntitlementRef },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementUserBindingExpandMask },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBindingRef }
        ]);
    }
    create(value?: PartialMessage<ListMembershipsRequest>): ListMembershipsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.query = "";
        message.refs = [];
        if (value !== undefined)
            reflectionMergePartial<ListMembershipsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListMembershipsRequest): ListMembershipsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string query */ 3:
                    message.query = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementRef entitlement_ref */ 4:
                    message.entitlementRef = AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options, message.entitlementRef);
                    break;
                case /* c1.api.app.v1.AppEntitlementUserBindingExpandMask expand_mask */ 5:
                    message.expandMask = AppEntitlementUserBindingExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementUserBindingRef refs */ 6:
                    message.refs.push(AppEntitlementUserBindingRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListMembershipsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string query = 3; */
        if (message.query !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.query);
        /* c1.api.app.v1.AppEntitlementRef entitlement_ref = 4; */
        if (message.entitlementRef)
            AppEntitlementRef.internalBinaryWrite(message.entitlementRef, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.AppEntitlementUserBindingExpandMask expand_mask = 5; */
        if (message.expandMask)
            AppEntitlementUserBindingExpandMask.internalBinaryWrite(message.expandMask, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppEntitlementUserBindingRef refs = 6; */
        for (let i = 0; i < message.refs.length; i++)
            AppEntitlementUserBindingRef.internalBinaryWrite(message.refs[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListMembershipsRequest
 */
export const ListMembershipsRequest = new ListMembershipsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppUsersForIdentityWithGrantRequest$Type extends MessageType<ListAppUsersForIdentityWithGrantRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppUsersForIdentityWithGrantRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "identity_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ListAppUsersForIdentityWithGrantRequest>): ListAppUsersForIdentityWithGrantRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.identityUserId = "";
        if (value !== undefined)
            reflectionMergePartial<ListAppUsersForIdentityWithGrantRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppUsersForIdentityWithGrantRequest): ListAppUsersForIdentityWithGrantRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string identity_user_id */ 3:
                    message.identityUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppUsersForIdentityWithGrantRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string identity_user_id = 3; */
        if (message.identityUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.identityUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppUsersForIdentityWithGrantRequest
 */
export const ListAppUsersForIdentityWithGrantRequest = new ListAppUsersForIdentityWithGrantRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppUsersForIdentityWithGrantResponse$Type extends MessageType<ListAppUsersForIdentityWithGrantResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppUsersForIdentityWithGrantResponse", [
            { no: 1, name: "bindings", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBinding }
        ]);
    }
    create(value?: PartialMessage<ListAppUsersForIdentityWithGrantResponse>): ListAppUsersForIdentityWithGrantResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.bindings = [];
        if (value !== undefined)
            reflectionMergePartial<ListAppUsersForIdentityWithGrantResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListAppUsersForIdentityWithGrantResponse): ListAppUsersForIdentityWithGrantResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementUserBinding bindings */ 1:
                    message.bindings.push(AppEntitlementUserBinding.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListAppUsersForIdentityWithGrantResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementUserBinding bindings = 1; */
        for (let i = 0; i < message.bindings.length; i++)
            AppEntitlementUserBinding.internalBinaryWrite(message.bindings[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppUsersForIdentityWithGrantResponse
 */
export const ListAppUsersForIdentityWithGrantResponse = new ListAppUsersForIdentityWithGrantResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementUserBinding$Type extends MessageType<AppEntitlementUserBinding> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementUserBinding", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }, { readOnlySpec: true }] } } },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }, { readOnlySpec: true }] } } },
            { no: 6, name: "deprovision_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "grant_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementUserBinding>): AppEntitlementUserBinding {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.appUserId = "";
        message.grantSources = [];
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementUserBinding>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementUserBinding): AppEntitlementUserBinding {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string app_user_id */ 3:
                    message.appUserId = reader.string();
                    break;
                case /* google.protobuf.Timestamp created_at */ 4:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp deleted_at */ 5:
                    message.deletedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deletedAt);
                    break;
                case /* google.protobuf.Timestamp deprovision_at */ 6:
                    message.deprovisionAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.deprovisionAt);
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef grant_sources */ 7:
                    message.grantSources.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementUserBinding, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string app_user_id = 3; */
        if (message.appUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appUserId);
        /* google.protobuf.Timestamp created_at = 4; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deleted_at = 5; */
        if (message.deletedAt)
            Timestamp.internalBinaryWrite(message.deletedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp deprovision_at = 6; */
        if (message.deprovisionAt)
            Timestamp.internalBinaryWrite(message.deprovisionAt, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppEntitlementRef grant_sources = 7; */
        for (let i = 0; i < message.grantSources.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.grantSources[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementUserBinding
 */
export const AppEntitlementUserBinding = new AppEntitlementUserBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementUserBindingHistory$Type extends MessageType<AppEntitlementUserBindingHistory> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementUserBindingHistory", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "granted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "revoked_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementUserBindingHistory>): AppEntitlementUserBindingHistory {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.appUserId = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementUserBindingHistory>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementUserBindingHistory): AppEntitlementUserBindingHistory {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string app_user_id */ 3:
                    message.appUserId = reader.string();
                    break;
                case /* google.protobuf.Timestamp granted_at */ 4:
                    message.grantedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.grantedAt);
                    break;
                case /* google.protobuf.Timestamp revoked_at */ 5:
                    message.revokedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.revokedAt);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementUserBindingHistory, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string app_user_id = 3; */
        if (message.appUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appUserId);
        /* google.protobuf.Timestamp granted_at = 4; */
        if (message.grantedAt)
            Timestamp.internalBinaryWrite(message.grantedAt, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp revoked_at = 5; */
        if (message.revokedAt)
            Timestamp.internalBinaryWrite(message.revokedAt, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementUserBindingHistory
 */
export const AppEntitlementUserBindingHistory = new AppEntitlementUserBindingHistory$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementUserBindingExpandHistoryMask$Type extends MessageType<AppEntitlementUserBindingExpandHistoryMask> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementUserBindingExpandHistoryMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_user_id", "app_id", "app_entitlement_id", "ticket_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementUserBindingExpandHistoryMask>): AppEntitlementUserBindingExpandHistoryMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementUserBindingExpandHistoryMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementUserBindingExpandHistoryMask): AppEntitlementUserBindingExpandHistoryMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementUserBindingExpandHistoryMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementUserBindingExpandHistoryMask
 */
export const AppEntitlementUserBindingExpandHistoryMask = new AppEntitlementUserBindingExpandHistoryMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementUserBindingHistoryView$Type extends MessageType<AppEntitlementUserBindingHistoryView> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementUserBindingHistoryView", [
            { no: 1, name: "history", kind: "message", T: () => AppEntitlementUserBindingHistory },
            { no: 2, name: "app_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "entitlement_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementUserBindingHistoryView>): AppEntitlementUserBindingHistoryView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appUserPath = "";
        message.entitlementPath = "";
        message.appPath = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementUserBindingHistoryView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementUserBindingHistoryView): AppEntitlementUserBindingHistoryView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementUserBindingHistory history */ 1:
                    message.history = AppEntitlementUserBindingHistory.internalBinaryRead(reader, reader.uint32(), options, message.history);
                    break;
                case /* string app_user_path */ 2:
                    message.appUserPath = reader.string();
                    break;
                case /* string entitlement_path */ 3:
                    message.entitlementPath = reader.string();
                    break;
                case /* string app_path */ 4:
                    message.appPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementUserBindingHistoryView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementUserBindingHistory history = 1; */
        if (message.history)
            AppEntitlementUserBindingHistory.internalBinaryWrite(message.history, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string app_user_path = 2; */
        if (message.appUserPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appUserPath);
        /* string entitlement_path = 3; */
        if (message.entitlementPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.entitlementPath);
        /* string app_path = 4; */
        if (message.appPath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementUserBindingHistoryView
 */
export const AppEntitlementUserBindingHistoryView = new AppEntitlementUserBindingHistoryView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchPastGrantsRequest$Type extends MessageType<SearchPastGrantsRequest> {
    constructor() {
        super("c1.api.app.v1.SearchPastGrantsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppEntitlementUserBindingExpandHistoryMask },
            { no: 5, name: "app_user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef },
            { no: 6, name: "app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef },
            { no: 7, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchPastGrantsRequest>): SearchPastGrantsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.appUserRefs = [];
        message.appEntitlementRefs = [];
        message.appIds = [];
        if (value !== undefined)
            reflectionMergePartial<SearchPastGrantsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchPastGrantsRequest): SearchPastGrantsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementUserBindingExpandHistoryMask expand_mask */ 4:
                    message.expandMask = AppEntitlementUserBindingExpandHistoryMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated c1.api.app.v1.AppUserRef app_user_refs */ 5:
                    message.appUserRefs.push(AppUserRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs */ 6:
                    message.appEntitlementRefs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated string app_ids */ 7:
                    message.appIds.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchPastGrantsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppEntitlementUserBindingExpandHistoryMask expand_mask = 4; */
        if (message.expandMask)
            AppEntitlementUserBindingExpandHistoryMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppUserRef app_user_refs = 5; */
        for (let i = 0; i < message.appUserRefs.length; i++)
            AppUserRef.internalBinaryWrite(message.appUserRefs[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 6; */
        for (let i = 0; i < message.appEntitlementRefs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.appEntitlementRefs[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* repeated string app_ids = 7; */
        for (let i = 0; i < message.appIds.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.appIds[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchPastGrantsRequest
 */
export const SearchPastGrantsRequest = new SearchPastGrantsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchPastGrantsResponse$Type extends MessageType<SearchPastGrantsResponse> {
    constructor() {
        super("c1.api.app.v1.SearchPastGrantsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBindingHistoryView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<SearchPastGrantsResponse>): SearchPastGrantsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<SearchPastGrantsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchPastGrantsResponse): SearchPastGrantsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementUserBindingHistoryView list */ 1:
                    message.list.push(AppEntitlementUserBindingHistoryView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchPastGrantsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementUserBindingHistoryView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementUserBindingHistoryView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchPastGrantsResponse
 */
export const SearchPastGrantsResponse = new SearchPastGrantsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementUserBindingFeed$Type extends MessageType<AppEntitlementUserBindingFeed> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementUserBindingFeed", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "date", kind: "message", T: () => Timestamp },
            { no: 5, name: "event_type", kind: "enum", T: () => ["c1.api.app.v1.GrantEventType", GrantEventType, "GRANT_EVENT_TYPE_"] },
            { no: 6, name: "ticket_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementUserBindingFeed>): AppEntitlementUserBindingFeed {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.appUserId = "";
        message.eventType = 0;
        message.ticketId = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementUserBindingFeed>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementUserBindingFeed): AppEntitlementUserBindingFeed {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string app_user_id */ 3:
                    message.appUserId = reader.string();
                    break;
                case /* google.protobuf.Timestamp date */ 4:
                    message.date = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.date);
                    break;
                case /* c1.api.app.v1.GrantEventType event_type */ 5:
                    message.eventType = reader.int32();
                    break;
                case /* string ticket_id */ 6:
                    message.ticketId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementUserBindingFeed, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string app_user_id = 3; */
        if (message.appUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appUserId);
        /* google.protobuf.Timestamp date = 4; */
        if (message.date)
            Timestamp.internalBinaryWrite(message.date, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.api.app.v1.GrantEventType event_type = 5; */
        if (message.eventType !== 0)
            writer.tag(5, WireType.Varint).int32(message.eventType);
        /* string ticket_id = 6; */
        if (message.ticketId !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.ticketId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementUserBindingFeed
 */
export const AppEntitlementUserBindingFeed = new AppEntitlementUserBindingFeed$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementUserBindingFeedView$Type extends MessageType<AppEntitlementUserBindingFeedView> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementUserBindingFeedView", [
            { no: 1, name: "feed", kind: "message", T: () => AppEntitlementUserBindingFeed },
            { no: 2, name: "app_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "entitlement_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "ticket_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementUserBindingFeedView>): AppEntitlementUserBindingFeedView {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appUserPath = "";
        message.entitlementPath = "";
        message.appPath = "";
        message.ticketPath = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementUserBindingFeedView>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementUserBindingFeedView): AppEntitlementUserBindingFeedView {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementUserBindingFeed feed */ 1:
                    message.feed = AppEntitlementUserBindingFeed.internalBinaryRead(reader, reader.uint32(), options, message.feed);
                    break;
                case /* string app_user_path */ 2:
                    message.appUserPath = reader.string();
                    break;
                case /* string entitlement_path */ 3:
                    message.entitlementPath = reader.string();
                    break;
                case /* string app_path */ 4:
                    message.appPath = reader.string();
                    break;
                case /* string ticket_path */ 5:
                    message.ticketPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementUserBindingFeedView, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementUserBindingFeed feed = 1; */
        if (message.feed)
            AppEntitlementUserBindingFeed.internalBinaryWrite(message.feed, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string app_user_path = 2; */
        if (message.appUserPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appUserPath);
        /* string entitlement_path = 3; */
        if (message.entitlementPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.entitlementPath);
        /* string app_path = 4; */
        if (message.appPath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appPath);
        /* string ticket_path = 5; */
        if (message.ticketPath !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.ticketPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementUserBindingFeedView
 */
export const AppEntitlementUserBindingFeedView = new AppEntitlementUserBindingFeedView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchGrantFeedRequest$Type extends MessageType<SearchGrantFeedRequest> {
    constructor() {
        super("c1.api.app.v1.SearchGrantFeedRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppEntitlementUserBindingExpandHistoryMask },
            { no: 4, name: "app_user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef },
            { no: 5, name: "app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef },
            { no: 6, name: "before", kind: "message", T: () => Timestamp },
            { no: 7, name: "after", kind: "message", T: () => Timestamp },
            { no: 8, name: "app_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppRef },
            { no: 9, name: "user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserRef }
        ]);
    }
    create(value?: PartialMessage<SearchGrantFeedRequest>): SearchGrantFeedRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.appUserRefs = [];
        message.appEntitlementRefs = [];
        message.appRefs = [];
        message.userRefs = [];
        if (value !== undefined)
            reflectionMergePartial<SearchGrantFeedRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchGrantFeedRequest): SearchGrantFeedRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementUserBindingExpandHistoryMask expand_mask */ 3:
                    message.expandMask = AppEntitlementUserBindingExpandHistoryMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                case /* repeated c1.api.app.v1.AppUserRef app_user_refs */ 4:
                    message.appUserRefs.push(AppUserRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs */ 5:
                    message.appEntitlementRefs.push(AppEntitlementRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* google.protobuf.Timestamp before */ 6:
                    message.before = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.before);
                    break;
                case /* google.protobuf.Timestamp after */ 7:
                    message.after = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.after);
                    break;
                case /* repeated c1.api.app.v1.AppRef app_refs */ 8:
                    message.appRefs.push(AppRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.api.user.v1.UserRef user_refs */ 9:
                    message.userRefs.push(UserRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchGrantFeedRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppEntitlementUserBindingExpandHistoryMask expand_mask = 3; */
        if (message.expandMask)
            AppEntitlementUserBindingExpandHistoryMask.internalBinaryWrite(message.expandMask, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppUserRef app_user_refs = 4; */
        for (let i = 0; i < message.appUserRefs.length; i++)
            AppUserRef.internalBinaryWrite(message.appUserRefs[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 5; */
        for (let i = 0; i < message.appEntitlementRefs.length; i++)
            AppEntitlementRef.internalBinaryWrite(message.appEntitlementRefs[i], writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp before = 6; */
        if (message.before)
            Timestamp.internalBinaryWrite(message.before, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp after = 7; */
        if (message.after)
            Timestamp.internalBinaryWrite(message.after, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.app.v1.AppRef app_refs = 8; */
        for (let i = 0; i < message.appRefs.length; i++)
            AppRef.internalBinaryWrite(message.appRefs[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.api.user.v1.UserRef user_refs = 9; */
        for (let i = 0; i < message.userRefs.length; i++)
            UserRef.internalBinaryWrite(message.userRefs[i], writer.tag(9, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchGrantFeedRequest
 */
export const SearchGrantFeedRequest = new SearchGrantFeedRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchGrantFeedResponse$Type extends MessageType<SearchGrantFeedResponse> {
    constructor() {
        super("c1.api.app.v1.SearchGrantFeedResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBindingFeedView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<SearchGrantFeedResponse>): SearchGrantFeedResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.expanded = [];
        if (value !== undefined)
            reflectionMergePartial<SearchGrantFeedResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchGrantFeedResponse): SearchGrantFeedResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementUserBindingFeedView list */ 1:
                    message.list.push(AppEntitlementUserBindingFeedView.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any expanded */ 3:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchGrantFeedResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementUserBindingFeedView list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementUserBindingFeedView.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any expanded = 3; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchGrantFeedResponse
 */
export const SearchGrantFeedResponse = new SearchGrantFeedResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementUserBindingExpandMask$Type extends MessageType<AppEntitlementUserBindingExpandMask> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementUserBindingExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_user_id", "app_id", "app_entitlement_id", "user_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementUserBindingExpandMask>): AppEntitlementUserBindingExpandMask {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.paths = [];
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementUserBindingExpandMask>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementUserBindingExpandMask): AppEntitlementUserBindingExpandMask {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string paths */ 1:
                    message.paths.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementUserBindingExpandMask, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string paths = 1; */
        for (let i = 0; i < message.paths.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.paths[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementUserBindingExpandMask
 */
export const AppEntitlementUserBindingExpandMask = new AppEntitlementUserBindingExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppUsersWithStandingHighRiskGrantsRequest$Type extends MessageType<SearchAppUsersWithStandingHighRiskGrantsRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppUsersWithStandingHighRiskGrantsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppEntitlementUserBindingExpandMask }
        ]);
    }
    create(value?: PartialMessage<SearchAppUsersWithStandingHighRiskGrantsRequest>): SearchAppUsersWithStandingHighRiskGrantsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.pageSize = 0;
        message.pageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppUsersWithStandingHighRiskGrantsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppUsersWithStandingHighRiskGrantsRequest): SearchAppUsersWithStandingHighRiskGrantsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* int32 page_size */ 2:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 3:
                    message.pageToken = reader.string();
                    break;
                case /* c1.api.app.v1.AppEntitlementUserBindingExpandMask expand_mask */ 4:
                    message.expandMask = AppEntitlementUserBindingExpandMask.internalBinaryRead(reader, reader.uint32(), options, message.expandMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppUsersWithStandingHighRiskGrantsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* int32 page_size = 2; */
        if (message.pageSize !== 0)
            writer.tag(2, WireType.Varint).int32(message.pageSize);
        /* string page_token = 3; */
        if (message.pageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.pageToken);
        /* c1.api.app.v1.AppEntitlementUserBindingExpandMask expand_mask = 4; */
        if (message.expandMask)
            AppEntitlementUserBindingExpandMask.internalBinaryWrite(message.expandMask, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppUsersWithStandingHighRiskGrantsRequest
 */
export const SearchAppUsersWithStandingHighRiskGrantsRequest = new SearchAppUsersWithStandingHighRiskGrantsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppAppUserEntitlementIds$Type extends MessageType<AppAppUserEntitlementIds> {
    constructor() {
        super("c1.api.app.v1.AppAppUserEntitlementIds", [
            { no: 1, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppAppUserEntitlementIds>): AppAppUserEntitlementIds {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appUserId = "";
        message.entitlementId = "";
        message.appId = "";
        message.userId = "";
        if (value !== undefined)
            reflectionMergePartial<AppAppUserEntitlementIds>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppAppUserEntitlementIds): AppAppUserEntitlementIds {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_user_id */ 1:
                    message.appUserId = reader.string();
                    break;
                case /* string entitlement_id */ 2:
                    message.entitlementId = reader.string();
                    break;
                case /* string app_id */ 3:
                    message.appId = reader.string();
                    break;
                case /* string user_id */ 4:
                    message.userId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppAppUserEntitlementIds, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_user_id = 1; */
        if (message.appUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appUserId);
        /* string entitlement_id = 2; */
        if (message.entitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.entitlementId);
        /* string app_id = 3; */
        if (message.appId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appId);
        /* string user_id = 4; */
        if (message.userId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppAppUserEntitlementIds
 */
export const AppAppUserEntitlementIds = new AppAppUserEntitlementIds$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementUserBindingExpanded$Type extends MessageType<AppEntitlementUserBindingExpanded> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementUserBindingExpanded", [
            { no: 1, name: "scope", kind: "message", T: () => AppAppUserEntitlementIds },
            { no: 2, name: "app_user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "entitlement_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "user_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<AppEntitlementUserBindingExpanded>): AppEntitlementUserBindingExpanded {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appUserPath = "";
        message.entitlementPath = "";
        message.appPath = "";
        message.userPath = "";
        if (value !== undefined)
            reflectionMergePartial<AppEntitlementUserBindingExpanded>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: AppEntitlementUserBindingExpanded): AppEntitlementUserBindingExpanded {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppAppUserEntitlementIds scope */ 1:
                    message.scope = AppAppUserEntitlementIds.internalBinaryRead(reader, reader.uint32(), options, message.scope);
                    break;
                case /* string app_user_path */ 2:
                    message.appUserPath = reader.string();
                    break;
                case /* string entitlement_path */ 3:
                    message.entitlementPath = reader.string();
                    break;
                case /* string app_path */ 4:
                    message.appPath = reader.string();
                    break;
                case /* string user_path */ 5:
                    message.userPath = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: AppEntitlementUserBindingExpanded, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppAppUserEntitlementIds scope = 1; */
        if (message.scope)
            AppAppUserEntitlementIds.internalBinaryWrite(message.scope, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string app_user_path = 2; */
        if (message.appUserPath !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appUserPath);
        /* string entitlement_path = 3; */
        if (message.entitlementPath !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.entitlementPath);
        /* string app_path = 4; */
        if (message.appPath !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appPath);
        /* string user_path = 5; */
        if (message.userPath !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.userPath);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementUserBindingExpanded
 */
export const AppEntitlementUserBindingExpanded = new AppEntitlementUserBindingExpanded$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppUsersWithStandingHighRiskGrantsResponse$Type extends MessageType<SearchAppUsersWithStandingHighRiskGrantsResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppUsersWithStandingHighRiskGrantsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBindingExpanded },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchAppUsersWithStandingHighRiskGrantsResponse>): SearchAppUsersWithStandingHighRiskGrantsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.expanded = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchAppUsersWithStandingHighRiskGrantsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchAppUsersWithStandingHighRiskGrantsResponse): SearchAppUsersWithStandingHighRiskGrantsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.AppEntitlementUserBindingExpanded list */ 1:
                    message.list.push(AppEntitlementUserBindingExpanded.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated google.protobuf.Any expanded */ 2:
                    message.expanded.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 3:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchAppUsersWithStandingHighRiskGrantsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.AppEntitlementUserBindingExpanded list = 1; */
        for (let i = 0; i < message.list.length; i++)
            AppEntitlementUserBindingExpanded.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any expanded = 2; */
        for (let i = 0; i < message.expanded.length; i++)
            Any.internalBinaryWrite(message.expanded[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 3; */
        if (message.nextPageToken !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppUsersWithStandingHighRiskGrantsResponse
 */
export const SearchAppUsersWithStandingHighRiskGrantsResponse = new SearchAppUsersWithStandingHighRiskGrantsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListGrantOriginsRequest$Type extends MessageType<ListGrantOriginsRequest> {
    constructor() {
        super("c1.api.app.v1.ListGrantOriginsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ListGrantOriginsRequest>): ListGrantOriginsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.appUserId = "";
        if (value !== undefined)
            reflectionMergePartial<ListGrantOriginsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListGrantOriginsRequest): ListGrantOriginsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string app_user_id */ 3:
                    message.appUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListGrantOriginsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string app_user_id = 3; */
        if (message.appUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListGrantOriginsRequest
 */
export const ListGrantOriginsRequest = new ListGrantOriginsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantOriginWithData$Type extends MessageType<GrantOriginWithData> {
    constructor() {
        super("c1.api.app.v1.GrantOriginWithData", [
            { no: 1, name: "origin_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "origin_data", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GrantOriginWithData>): GrantOriginWithData {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.originType = "";
        message.originData = [];
        if (value !== undefined)
            reflectionMergePartial<GrantOriginWithData>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GrantOriginWithData): GrantOriginWithData {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string origin_type */ 1:
                    message.originType = reader.string();
                    break;
                case /* repeated string origin_data */ 2:
                    message.originData.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GrantOriginWithData, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string origin_type = 1; */
        if (message.originType !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.originType);
        /* repeated string origin_data = 2; */
        for (let i = 0; i < message.originData.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.originData[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GrantOriginWithData
 */
export const GrantOriginWithData = new GrantOriginWithData$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListGrantOriginsResponse$Type extends MessageType<ListGrantOriginsResponse> {
    constructor() {
        super("c1.api.app.v1.ListGrantOriginsResponse", [
            { no: 1, name: "origins", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GrantOriginWithData }
        ]);
    }
    create(value?: PartialMessage<ListGrantOriginsResponse>): ListGrantOriginsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.origins = [];
        if (value !== undefined)
            reflectionMergePartial<ListGrantOriginsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ListGrantOriginsResponse): ListGrantOriginsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.GrantOriginWithData origins */ 1:
                    message.origins.push(GrantOriginWithData.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ListGrantOriginsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.GrantOriginWithData origins = 1; */
        for (let i = 0; i < message.origins.length; i++)
            GrantOriginWithData.internalBinaryWrite(message.origins[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListGrantOriginsResponse
 */
export const ListGrantOriginsResponse = new ListGrantOriginsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchGrantReasonsRequest$Type extends MessageType<SearchGrantReasonsRequest> {
    constructor() {
        super("c1.api.app.v1.SearchGrantReasonsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 6, name: "grant_reason_types", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "4" } } } },
            { no: 7, name: "include_weak_reasons", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<SearchGrantReasonsRequest>): SearchGrantReasonsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.appId = "";
        message.appEntitlementId = "";
        message.appUserId = "";
        message.grantReasonTypes = [];
        message.includeWeakReasons = false;
        if (value !== undefined)
            reflectionMergePartial<SearchGrantReasonsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchGrantReasonsRequest): SearchGrantReasonsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 page_size */ 1:
                    message.pageSize = reader.int32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* string app_id */ 3:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 4:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string app_user_id */ 5:
                    message.appUserId = reader.string();
                    break;
                case /* repeated string grant_reason_types */ 6:
                    message.grantReasonTypes.push(reader.string());
                    break;
                case /* bool include_weak_reasons */ 7:
                    message.includeWeakReasons = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchGrantReasonsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).int32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* string app_id = 3; */
        if (message.appId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 4; */
        if (message.appEntitlementId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string app_user_id = 5; */
        if (message.appUserId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.appUserId);
        /* repeated string grant_reason_types = 6; */
        for (let i = 0; i < message.grantReasonTypes.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.grantReasonTypes[i]);
        /* bool include_weak_reasons = 7; */
        if (message.includeWeakReasons !== false)
            writer.tag(7, WireType.Varint).bool(message.includeWeakReasons);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchGrantReasonsRequest
 */
export const SearchGrantReasonsRequest = new SearchGrantReasonsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchGrantReasonsResponse$Type extends MessageType<SearchGrantReasonsResponse> {
    constructor() {
        super("c1.api.app.v1.SearchGrantReasonsResponse", [
            { no: 1, name: "reasons", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GrantReason },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<SearchGrantReasonsResponse>): SearchGrantReasonsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.reasons = [];
        message.nextPageToken = "";
        if (value !== undefined)
            reflectionMergePartial<SearchGrantReasonsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchGrantReasonsResponse): SearchGrantReasonsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.app.v1.GrantReason reasons */ 1:
                    message.reasons.push(GrantReason.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchGrantReasonsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.app.v1.GrantReason reasons = 1; */
        for (let i = 0; i < message.reasons.length; i++)
            GrantReason.internalBinaryWrite(message.reasons[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchGrantReasonsResponse
 */
export const SearchGrantReasonsResponse = new SearchGrantReasonsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GrantSource$Type extends MessageType<GrantSource> {
    constructor() {
        super("c1.api.app.v1.GrantSource", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<GrantSource>): GrantSource {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<GrantSource>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GrantSource): GrantSource {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GrantSource, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GrantSource
 */
export const GrantSource = new GrantSource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppEntitlementUserBindingRequest$Type extends MessageType<GetAppEntitlementUserBindingRequest> {
    constructor() {
        super("c1.api.app.v1.GetAppEntitlementUserBindingRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<GetAppEntitlementUserBindingRequest>): GetAppEntitlementUserBindingRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.appUserId = "";
        if (value !== undefined)
            reflectionMergePartial<GetAppEntitlementUserBindingRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAppEntitlementUserBindingRequest): GetAppEntitlementUserBindingRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string app_user_id */ 3:
                    message.appUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAppEntitlementUserBindingRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string app_user_id = 3; */
        if (message.appUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppEntitlementUserBindingRequest
 */
export const GetAppEntitlementUserBindingRequest = new GetAppEntitlementUserBindingRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppEntitlementUserBindingResponse$Type extends MessageType<GetAppEntitlementUserBindingResponse> {
    constructor() {
        super("c1.api.app.v1.GetAppEntitlementUserBindingResponse", [
            { no: 1, name: "binding", kind: "message", T: () => AppEntitlementUserBinding }
        ]);
    }
    create(value?: PartialMessage<GetAppEntitlementUserBindingResponse>): GetAppEntitlementUserBindingResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetAppEntitlementUserBindingResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetAppEntitlementUserBindingResponse): GetAppEntitlementUserBindingResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementUserBinding binding */ 1:
                    message.binding = AppEntitlementUserBinding.internalBinaryRead(reader, reader.uint32(), options, message.binding);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetAppEntitlementUserBindingResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementUserBinding binding = 1; */
        if (message.binding)
            AppEntitlementUserBinding.internalBinaryWrite(message.binding, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppEntitlementUserBindingResponse
 */
export const GetAppEntitlementUserBindingResponse = new GetAppEntitlementUserBindingResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveGrantDurationRequest$Type extends MessageType<RemoveGrantDurationRequest> {
    constructor() {
        super("c1.api.app.v1.RemoveGrantDurationRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<RemoveGrantDurationRequest>): RemoveGrantDurationRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        message.appUserId = "";
        if (value !== undefined)
            reflectionMergePartial<RemoveGrantDurationRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoveGrantDurationRequest): RemoveGrantDurationRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                case /* string app_user_id */ 3:
                    message.appUserId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoveGrantDurationRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        /* string app_user_id = 3; */
        if (message.appUserId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.appUserId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RemoveGrantDurationRequest
 */
export const RemoveGrantDurationRequest = new RemoveGrantDurationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveGrantDurationResponse$Type extends MessageType<RemoveGrantDurationResponse> {
    constructor() {
        super("c1.api.app.v1.RemoveGrantDurationResponse", [
            { no: 1, name: "binding", kind: "message", T: () => AppEntitlementUserBinding }
        ]);
    }
    create(value?: PartialMessage<RemoveGrantDurationResponse>): RemoveGrantDurationResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<RemoveGrantDurationResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: RemoveGrantDurationResponse): RemoveGrantDurationResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.app.v1.AppEntitlementUserBinding binding */ 1:
                    message.binding = AppEntitlementUserBinding.internalBinaryRead(reader, reader.uint32(), options, message.binding);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: RemoveGrantDurationResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.app.v1.AppEntitlementUserBinding binding = 1; */
        if (message.binding)
            AppEntitlementUserBinding.internalBinaryWrite(message.binding, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RemoveGrantDurationResponse
 */
export const RemoveGrantDurationResponse = new RemoveGrantDurationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchExpiringAppEntitlementsCountRequest$Type extends MessageType<SearchExpiringAppEntitlementsCountRequest> {
    constructor() {
        super("c1.api.app.v1.SearchExpiringAppEntitlementsCountRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<SearchExpiringAppEntitlementsCountRequest>): SearchExpiringAppEntitlementsCountRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.appId = "";
        message.appEntitlementId = "";
        if (value !== undefined)
            reflectionMergePartial<SearchExpiringAppEntitlementsCountRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchExpiringAppEntitlementsCountRequest): SearchExpiringAppEntitlementsCountRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string app_id */ 1:
                    message.appId = reader.string();
                    break;
                case /* string app_entitlement_id */ 2:
                    message.appEntitlementId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchExpiringAppEntitlementsCountRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string app_id = 1; */
        if (message.appId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.appId);
        /* string app_entitlement_id = 2; */
        if (message.appEntitlementId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.appEntitlementId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchExpiringAppEntitlementsCountRequest
 */
export const SearchExpiringAppEntitlementsCountRequest = new SearchExpiringAppEntitlementsCountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchExpiringAppEntitlementsCountResponse$Type extends MessageType<SearchExpiringAppEntitlementsCountResponse> {
    constructor() {
        super("c1.api.app.v1.SearchExpiringAppEntitlementsCountResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
    create(value?: PartialMessage<SearchExpiringAppEntitlementsCountResponse>): SearchExpiringAppEntitlementsCountResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial<SearchExpiringAppEntitlementsCountResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: SearchExpiringAppEntitlementsCountResponse): SearchExpiringAppEntitlementsCountResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int64 count */ 1:
                    message.count = reader.int64().toNumber();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: SearchExpiringAppEntitlementsCountResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int64 count = 1; */
        if (message.count !== 0)
            writer.tag(1, WireType.Varint).int64(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchExpiringAppEntitlementsCountResponse
 */
export const SearchExpiringAppEntitlementsCountResponse = new SearchExpiringAppEntitlementsCountResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppEntitlementUserBindingService
 */
export const AppEntitlementUserBindingService = new ServiceType("c1.api.app.v1.AppEntitlementUserBindingService", [
    { name: "ListAppUsersForIdentityWithGrant", options: { "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/users/{identity_user_id}/grants", group: "App Entitlement User Binding" }] }, "authz.method": { role: "VIEWER" } }, I: ListAppUsersForIdentityWithGrantRequest, O: ListAppUsersForIdentityWithGrantResponse },
    { name: "SearchPastGrants", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/past-grants", group: "App Entitlement User Binding History" }] }, "authz.method": { role: "VIEWER" } }, I: SearchPastGrantsRequest, O: SearchPastGrantsResponse },
    { name: "SearchGrantFeed", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/grants/feed", group: "App Entitlement User Binding Feed" }] }, "authz.method": { role: "VIEWER" } }, I: SearchGrantFeedRequest, O: SearchGrantFeedResponse },
    { name: "SearchAppUsersWithStandingHighRiskGrants", options: { "authz.method": { role: "EDITOR" } }, I: SearchAppUsersWithStandingHighRiskGrantsRequest, O: SearchAppUsersWithStandingHighRiskGrantsResponse },
    { name: "ListGrantOrigins", options: { "authz.method": { role: "VIEWER" } }, I: ListGrantOriginsRequest, O: ListGrantOriginsResponse },
    { name: "SearchGrantReasons", options: { "authz.method": { role: "VIEWER" } }, I: SearchGrantReasonsRequest, O: SearchGrantReasonsResponse },
    { name: "ListMemberships", options: { "authz.method": { role: "VIEWER" } }, I: ListMembershipsRequest, O: ListMembershipsResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: GetAppEntitlementUserBindingRequest, O: GetAppEntitlementUserBindingResponse },
    { name: "UpdateGrantDuration", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/users/{app_user_id}/update-grant-duration", group: "App Entitlement User Binding" }] }, "authz.method": { role: "OWNER" } }, I: UpdateGrantDurationRequest, O: UpdateGrantDurationResponse },
    { name: "RemoveGrantDuration", options: { "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/users/{app_user_id}/remove-grant-duration", group: "App Entitlement User Binding" }] }, "authz.method": { role: "OWNER" } }, I: RemoveGrantDurationRequest, O: RemoveGrantDurationResponse },
    { name: "SearchExpiringAppEntitlementsCount", options: { "authz.method": { role: "VIEWER" } }, I: SearchExpiringAppEntitlementsCountRequest, O: SearchExpiringAppEntitlementsCountResponse }
]);
